// Shopify contact form handles validation, anti-spam and delivery server-side.
document.querySelectorAll('.service-page form').forEach(function(form){
  form.querySelectorAll('[required]').forEach(function(field){
    field.addEventListener('input',function(){field.setCustomValidity(field.value.trim() ? '' : (window.AD_I18N["form.required"]));});
  });
});
var result=document.querySelector('[data-contact-result]');
if(result){result.focus({preventScroll:true});result.scrollIntoView({block:'center'});}
